module.exports = "<div class=\"no-project-history row\">\n    <div class=\"col-md-8 col-md-offset-2\">\n        <span class=\"icon icon-history-thin\"></span>\n        <p class=\"no-project-history-message\">History only available for projects started on or after 10/27/16</p>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/appDetail/projectHistory/noProjectHistory.html
// module id = 618
// module chunks = 1